namespace Nobox.CRM {
    export interface ProductsForm {
        ProductName: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        UnitIds: ProductUnitEditor;
        Spacer: Serenity.Extensions.StaticTextBlock;
        Currencies: CurrencyEditor;
        PriceList: AutoNumericEditor;
        Quantity: Serenity.IntegerEditor;
        Discount: Serenity.IntegerEditor;
        TotalPrice: Serenity.DecimalEditor;
        ManufacturIds: Serenity.StringEditor;
        Tags: Serenity.ServiceLookupEditor;
        ProductDesc: Serenity.TextAreaEditor;
        IsShowForm: Serenity.BooleanEditor;
        Image: Serenity.MultipleImageUploadEditor;
        isi: Serenity.Extensions.StaticTextBlock;
        Custom: Serenity.Extensions.StaticTextBlock;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        InBy: Serenity.ServiceLookupEditor;
        UpBy: Serenity.ServiceLookupEditor;
    }

    export class ProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Products';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductsForm.init)  {
                ProductsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = ProductUnitEditor;
                var w2 = s.Extensions.StaticTextBlock;
                var w3 = CurrencyEditor;
                var w4 = AutoNumericEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ServiceLookupEditor;
                var w8 = s.TextAreaEditor;
                var w9 = s.BooleanEditor;
                var w10 = s.MultipleImageUploadEditor;
                var w11 = CustomDateTimeEditor;

                Q.initFormType(ProductsForm, [
                    'ProductName', w0,
                    'ProductCode', w0,
                    'UnitIds', w1,
                    'Spacer', w2,
                    'Currencies', w3,
                    'PriceList', w4,
                    'Quantity', w5,
                    'Discount', w5,
                    'TotalPrice', w6,
                    'ManufacturIds', w0,
                    'Tags', w7,
                    'ProductDesc', w8,
                    'IsShowForm', w9,
                    'Image', w10,
                    'isi', w2,
                    'Custom', w2,
                    'In', w11,
                    'Up', w11,
                    'InBy', w7,
                    'UpBy', w7
                ]);
            }
        }
    }
}
